import { useCallback, useEffect } from "react";
import Confetti from "react-confetti";
import "./Popup.scss";

const Popup = ({
  data: { text, cta = [], animation = null, deeplink },
  response = [],
  next,
  set,
}) => {
  const done = useCallback(() => {
      const { screen, paramOne } = deeplink;
      if (["NEXT", "SKIP"].includes(screen))
        next(paramOne ? parseInt(paramOne) : 1, response);
    }, [deeplink, next, response]),
    handleClick = (deeplink) => {
      let { screen, paramOne } = deeplink;
      if (screen === "CANCEL") set(null);
      else if (["NEXT", "SKIP"].includes(screen))
        next(paramOne ? parseInt(paramOne) : 1, response);
    };
  useEffect(() => {
    let interval;
    if (cta.length === 0) {
      interval = setTimeout(() => done(), 5000);
    }
    return () => {
      clearTimeout(interval);
    };
  }, [cta.length, done]);
  return (
    <div className="emotion-popup">
      <div className="container emotion-popup-container">
        {animation === "POPPERS" && (
          <Confetti width={window.screen.width} height={window.screen.height} />
        )}
        <div className="emotion-popup-content">
          <div className="emotion-popup-text emotion-text">{text}</div>
        </div>
        <div className="emotion-cta">
          {cta.map((item, itemIndex) => (
            <div key={`cta${itemIndex}`} className="emotion-popup-cta">
              <button
                className={`emotion-basic-button${
                  itemIndex === 0 ? " emotion-basic-button-empty" : ""
                }`}
                onClick={() => handleClick(item.deeplink)}
              >
                {item.text}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Popup;
